export interface IFields {
  submitBasicData: boolean
  submitUsageStats: boolean
  submitAudienceData: boolean
}

export const initialFields = {
  submitBasicData: true,
  submitUsageStats: false,
  submitAudienceData: false,
}
